<template>
    <common-modal
        :heading="$t('pages.referrals.show.decline_modal.heading')"
        @emitEvent="emitEvent($event, ['close'])"
        @close="emitEvent({ name: 'close' })"
    >
        <common-content-spacer height="large">
            <common-content-spacer height="small">
                <radio-input :value="reason" :options="options" direction="column" @change="change('reason', $event)">
                    <template v-if="reason === 'slot_not_available'" #option-slot_not_available>
                        <common-content-spacer height="small">
                            <p>{{ $t('pages.referrals.show.decline_modal.want_reschedule') }}</p>

                            <common-buttons align="left">
                                <common-button
                                    :label="$t('pages.referrals.show.decline_modal.buttons.decline')"
                                    type="secondary"
                                    size="large"
                                    @click="emitEvent({ name: 'decline', payload: { reason: 'slot_not_available' } })"
                                ></common-button>

                                <common-button
                                    :label="$t('pages.referrals.show.decline_modal.buttons.reschedule')"
                                    type="primary"
                                    size="large"
                                    @click="emitEvent({ name: 'reschedule' })"
                                ></common-button>
                            </common-buttons>
                        </common-content-spacer>
                    </template>
                </radio-input>

                <textarea-input
                    v-if="reason === 'other'"
                    :placeholder="$t('pages.referrals.show.decline_modal.options.other.message')"
                    :isRequired="false"
                    @change="change('message', $event)"
                ></textarea-input>
            </common-content-spacer>

            <common-buttons>
                <common-button
                    :label="$t('pages.referrals.show.decline_modal.buttons.done')"
                    type="primary"
                    size="large"
                    @click="emitEvent({ name: 'decline', payload: { reason, message } })"
                ></common-button>
            </common-buttons>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import RadioInput from 'components/form-inputs/RadioInput'
    import TextareaInput from 'components/form-inputs/TextareaInput'

    export default {
        components: {
            RadioInput,
            TextareaInput,
        },

        props: {
            referral: { type: Object, required: true },
        },

        data() {
            return {
                reason: null,
                message: '',
            }
        },

        computed: {
            options() {
                return [
                    {
                        label: this.$t('pages.referrals.show.decline_modal.options.slot_not_available'),
                        value: 'slot_not_available',
                    },
                    {
                        label: this.$t('pages.referrals.show.decline_modal.options.insurance_not_accepted', {
                            name: this.referral.insurancePlan.name,
                        }),
                        value: 'insurance_not_accepted',
                    },
                    // TODO: Enable this for ancillary services.
                    // {
                    //     label: this.$t('pages.referrals.show.decline_modal.options.service_not_available', {
                    //         name: '[placeholder]',
                    //     }),
                    //     value: 'service_not_available',
                    // },
                    {
                        label: this.$t('pages.referrals.show.decline_modal.options.other.value'),
                        value: 'other',
                    },
                ]
            },
        },

        methods: {
            change(field, value) {
                this[field] = value
            },
        },
    }
</script>
